import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingErrorComponent } from './loading-error.component';

@NgModule({
  declarations: [LoadingErrorComponent],
  exports: [LoadingErrorComponent],
  imports: [CommonModule]
})
export class LoadingErrorModule {}
